export interface StudyPlan {
  id?: string;
  userId: string;
  planType: PlanType;
  startDate: Date;
  endDate: Date;
  minutesPerQuestion: number;
  flashcardsPerMinute: number;
  videosPerDay: number;
  unavailableDates: Date[];
  catchUpDays: CatchUpDay[];
  selectedDays?: any[];
  includesPracticeQuestions: boolean;
  includesFlashcards: boolean;
  includesCourseVideos: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export enum PlanType {
  SELECT_STUDY = 'selectStudy',
  MAX_FLEX = 'maxFlex'
}

export interface CatchUpDay {
  frequency: CatchUpFrequency;
  weekday: number; // 0 = Sunday, 1 = Monday, etc.
}

export enum CatchUpFrequency {
  EVERY = 'every',
  EVERY_OTHER = 'everyOther',
  EVERY_THIRD = 'everyThird',
  EVERY_FOURTH = 'everyFourth'
} 